import { render, staticRenderFns } from "./_changeEmailModal.vue?vue&type=template&id=5af8e6dd"
import script from "./_changeEmailModal.vue?vue&type=script&lang=js"
export * from "./_changeEmailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports